import { faClose } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material"

const Popup = ({title, subTitle, children, openPopup, setOpenPopup, minHeight = "400px", minWidth = "auto", novoCadastro, setNovoCadastro, hiddenCloseBtn, actions = []}) => {

    const closeWindow = () => {
        if (novoCadastro !== undefined && setNovoCadastro !== undefined) {
            setNovoCadastro(false);
            setOpenPopup(false);
        }

        setOpenPopup(false);
    }

    return (
        <Dialog open={openPopup} maxWidth="auto" >
            <DialogTitle sx={{ backgroundColor:"#232323"}}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ display: "flex", padding: "10px 0px 10px 45px" }}>
                        <h3 style={{ flexGrow: 1}}>
                            {title} {(subTitle) && ( <small>({subTitle})</small> )}
                        </h3>
                        <Button style={hiddenCloseBtn ? { display: "none"} : {}} onClick={closeWindow} >
                            <FontAwesomeIcon icon={faClose} />
                        </Button>
                    </div>
                    
                </div>
            </DialogTitle>
            <DialogContent style={children.key == "SolicitacaoAcesso"? {padding: "10px 7px"} : {}} sx={{ backgroundColor:"#232323", display: "flex", minHeight: minHeight, minWidth: minWidth}}>
                {children}
            </DialogContent>
            <DialogActions style={actions.length == 0 ? { display: "none"} : { padding: "8px 42px"}} sx={{ backgroundColor:"#232323", borderTop: "1px solid #494949"}}>
                { actions.map((action) => action) }
            </DialogActions>
        </Dialog>
    )
}

export { Popup }